document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-button');
  const nav = document.querySelector('.site-header nav');
  menu?.addEventListener('click', () => {
    const isOpen = nav?.classList.toggle('open') || false;
    menu.setAttribute('aria-expanded', String(isOpen));
  });

  const showToast = (message, duration = 2500) => {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), duration);
  };

  const money = (cents) => (cents / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  });

  document.querySelectorAll('[data-product]').forEach((root) => {
    const gallery = root.querySelector('[data-product-gallery]');
    const showMedia = (mediaId) => {
      if (!mediaId || !gallery) return;
      const media = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!media) return;
      gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.remove('is-selected-variant'));
      gallery.querySelectorAll('[data-gallery-target]').forEach((thumb) => thumb.removeAttribute('aria-current'));
      media.classList.add('is-selected-variant');
      gallery.querySelector(`[data-gallery-target="${mediaId}"]`)?.setAttribute('aria-current', 'true');
    };
    gallery?.querySelectorAll('[data-gallery-target]').forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.galleryTarget));
    });

    const bundle = root.querySelector('[data-mdb-bundle]');
    if (bundle) {
      const sizeSelect = bundle.querySelector('[data-bundle-size]');
      const button = bundle.querySelector('[data-bundle-add]');
      const note = bundle.querySelector('[data-bundle-note]');
      const shirtVariants = JSON.parse(bundle.querySelector('[data-shirt-variants]')?.textContent || '[]');
      const shortsVariants = JSON.parse(bundle.querySelector('[data-shorts-variants]')?.textContent || '[]');
      const shirtIndex = Number(bundle.dataset.shirtSizeIndex || 0);
      const shortsIndex = Number(bundle.dataset.shortsSizeIndex || 0);
      const normalizeSize = (value) => String(value || '').toLowerCase().replace(/extra/g, 'x').replace(/large/g, 'l').replace(/medium/g, 'm').replace(/small/g, 's').replace(/[^a-z0-9]/g, '');
      const matches = [];
      shirtVariants.forEach((shirt) => {
        const shirtSize = shirt.options?.[shirtIndex] || shirt.title;
        const key = normalizeSize(shirtSize);
        const shorts = shortsVariants.find((item) => normalizeSize(item.options?.[shortsIndex] || item.title) === key);
        if (shorts && shirt.available && shorts.available) matches.push({ size: shirtSize, shirtId: shirt.id, shortsId: shorts.id });
      });
      matches.forEach((match) => {
        const option = document.createElement('option');
        option.value = String(match.size);
        option.textContent = String(match.size);
        option.dataset.shirtVariant = String(match.shirtId);
        option.dataset.shortsVariant = String(match.shortsId);
        sizeSelect?.appendChild(option);
      });
      if (!matches.length && note) note.textContent = 'Set sizes are being updated. Please check back shortly.';
      sizeSelect?.addEventListener('change', () => {
        const option = sizeSelect.options[sizeSelect.selectedIndex];
        const valid = Boolean(option?.dataset.shirtVariant && option?.dataset.shortsVariant);
        button.disabled = !valid;
        button.dataset.shirtVariant = option?.dataset.shirtVariant || '';
        button.dataset.shortsVariant = option?.dataset.shortsVariant || '';
        button.querySelector('span').textContent = valid ? 'ADD FULL $75 SET TO BAG' : 'SELECT SIZE TO ADD FULL SET';
        if (note) note.textContent = valid ? `Selected size: ${option.value} for shirt + shorts` : '';
      });
      button?.addEventListener('click', async () => {
        if (button.disabled || !button.dataset.shirtVariant || !button.dataset.shortsVariant) return;
        button.disabled = true;
        const label = button.querySelector('span');
        label.textContent = 'ADDING BOTH PIECES...';
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [
              { id: Number(button.dataset.shirtVariant), quantity: 1, properties: { '_MDB Set': 'Rose Pink $75 Set', 'Set Size': sizeSelect.value } },
              { id: Number(button.dataset.shortsVariant), quantity: 1, properties: { '_MDB Set': 'Rose Pink $75 Set', 'Set Size': sizeSelect.value } }
            ] })
          });
          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'The complete set could not be added.');
          }
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (error) {
          showToast(error.message, 3500);
          button.disabled = false;
          label.textContent = 'ADD FULL $75 SET TO BAG';
        }
      });
      return;
    }

    const form = root.querySelector('[data-product-form]');
    if (!form) return;
    const variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
    const button = form.querySelector('.add-button');
    const variantInput = form.querySelector('[data-variant-id]');
    const showVariantMedia = (variant) => showMedia(variant?.featured_media?.id || variant?.featured_image?.id);
    const selectVariant = () => {
      const selected = [...form.querySelectorAll('fieldset')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!button || !variantInput) return;
      if (!variant) {
        variantInput.value = '';
        button.disabled = true;
        button.querySelector('span').textContent = 'CHOOSE ANOTHER OPTION';
        return;
      }
      variantInput.value = variant.id;
      button.disabled = !variant.available;
      button.querySelector('span').textContent = variant.available ? 'ADD TO BAG' : 'CHOOSE ANOTHER OPTION';
      button.querySelector('b').textContent = money(variant.price);
      const displayedPrice = root.querySelector('[data-price]');
      if (displayedPrice) displayedPrice.textContent = money(variant.price);
      showVariantMedia(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    root.querySelectorAll('input[type=radio]').forEach((input) => input.addEventListener('change', selectVariant));
    const selectedId = Number(variantInput?.value);
    showVariantMedia(variants.find((variant) => variant.id === selectedId));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!variantInput?.value || button?.disabled) return;
      const label = button.querySelector('span');
      const original = label.textContent;
      button.classList.add('loading');
      button.disabled = true;
      try {
        const add = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!add.ok) {
          const error = await add.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add this selection.');
        }
        const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
        if (!cartResponse.ok) throw new Error('Unable to refresh your bag.');
        const cart = await cartResponse.json();
        const count = document.querySelector('[data-cart-count]');
        if (count) count.textContent = cart.item_count;
        showToast('Added to your bag');
      } catch (error) {
        showToast(error.message, 3500);
      } finally {
        button.classList.remove('loading');
        button.disabled = original !== 'ADD TO BAG';
        label.textContent = original;
      }
    });
  });
});
